import { useState } from "react";
import From from "../../Formulario/Formulario";

const CardInfosDadosBancarios = () => {
    
            const [conta, setConta] = useState([])
    
            const aNovaContaAdicionada = (conta) =>{
                console.log(conta)
            }
    return (

        <div className="card">
            <div className="card-header">
                <h3>Informações da conta bancária</h3>
            </div>

            <div className="card-note">
                Preencha os campos abaixo com atenção. Em caso de dúvidas, consulte o suporte antes de confirmar.
            </div>
            
            <From aContaCadastrada={conta => aNovaContaAdicionada(conta)}/>

            <p className="role-info" id="role-info">
                Apenas o usuário licenciado pode editar esses dados. O administrador pode ter acesso em modo de visualização,
                conforme política interna.
            </p>

            <div className="alert success" id="success-alert">
                Dados bancários salvos com sucesso (simulação front-end). Integre com sua API para gravar no servidor.
            </div>
            <div className="alert error" id="error-alert">
                Revise os campos destacados em vermelho antes de continuar.
            </div>
        </div>
    );
};

export default CardInfosDadosBancarios;